<lib-prod-grid
  [title]="prodGridTitle"
  [icon]="'dataset'"
  [columns]="prodGridColumns"
  [matTableDataSource]="matTableDataSource"
  [inputAction$]="inputAction$"
  (outputAction$)="outputActionEvents($event)"></lib-prod-grid>
